import { SyntheticEvent, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { SetterOrUpdater, useRecoilValue } from "recoil";
import { CheckListRequestType, CommandType, CustomerListType, DepartmentSimpleType, SecretarySimpleType, SelectedParametersType, UserType, VehicleListType } from "../../../../types/types";
import { userAtom } from "../../../../atoms/atoms";
import { CHECKLIST_STATUS, CHECKLIST_TYPES, customerDefault, departmentDefault, getChecklistStatusByValue, getChecklistTypeByValue, secretaryDefault } from "../../../../consts/consts";
import { useCookies } from "react-cookie";
import { Toast } from "primereact/toast";
import { Alert, Autocomplete, Box, Button, Card, CardActions, Chip, createStyles, Fab, FormControl, FormControlLabel, FormGroup, IconButton, InputLabel, makeStyles, Menu, MenuItem, Paper, Stack, Step, StepContent, StepLabel, Stepper, styled, Switch, TextField, Theme, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { AbcOutlined, AddCircleOutlineOutlined, CalendarMonthOutlined, AddIcCallOutlined, AddOutlined, ArrowForwardOutlined, CachedOutlined, CheckCircleRounded, CloseOutlined, DoNotDisturbOnRounded, DownloadOutlined, FilePresentOutlined, FullscreenOutlined, GridOnOutlined, HandshakeOutlined, HideImageOutlined, KeyOutlined, LocalShippingRounded, PictureAsPdfOutlined, PrintOutlined, SendToMobileOutlined, UndoOutlined } from "@mui/icons-material";
import { getFilteredList, setToastRefToOpen } from "../../../../functions/functions";
import findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdListResponse from "../../../../resources/Api/vehicle/findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdListResponse";
import customerFindAllListResponse from "../../../../resources/Api/customer/customerFindAllListResponse";
import GridTemplate from "../../../../components/GridTemplate";
import { GridCloseIcon, GridColDef } from "@mui/x-data-grid";
import { useLocation } from "react-router-dom";
import checkListTypesFindAllByActivated from "../../../../resources/Api/checklist/checkListTypesFindAllByActivated";
import checklistsFindAllByActivated from "../../../../resources/Api/checklist/checkListsFindAllByActivated";
import Rmodal from "../../../../components/Rmodal";
import { Fieldset } from "primereact/fieldset";
import checkListSaveByVehicle from "../../../../resources/Api/checklist/checkListSaveByVehicle";
import checklistFindByIdExportResponse from "../../../../resources/Api/checklist/checklistFindByIdExportResponse";
import { MenuItem as MenuIt } from "primereact/menuitem";
import checklistFindLastExportResponse from "../../../../resources/Api/checklist/checklistFindLastExportResponse";
import { isImpersonationLocked } from "../../../../utils/impersonation";

const IOSSwitch = styled((props: any) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: 2,
        transitionDuration: "300ms",
        "&.Mui-checked": {
            transform: "translateX(16px)",
            color: "#fff",
            "& + .MuiSwitch-track": {
                backgroundColor: "#65C466",
                opacity: 1,
                border: 0
            }
        }
    },
    "& .MuiSwitch-thumb": {
        width: 22,
        height: 22
    },
    "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        backgroundColor: "#E9E9EA",
        opacity: 1
    }
}));

const items: MenuIt[] = [
    {
        label: 'PDF',
        icon: <PictureAsPdfOutlined />,
    },
    {
        label: 'Excel',
        icon: <GridOnOutlined />
    },
    {
        label: "Excel simples",
        icon: <GridOnOutlined />,
    },
];

const columns: GridColDef[] = [
    {
        field: "activated",
        type: "boolean",
        width: 150,
        editable: false,
        sortable: false,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Ativo"}
                icon={<KeyOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{ background: "transparent" }}
                icon={
                    item.row.activated ? (
                        <CheckCircleRounded
                            className="activated"
                            style={{ height: 28, width: 28 }}
                        />
                    ) : (
                        <DoNotDisturbOnRounded
                            className="deactivated"
                            style={{ height: 28, width: 28 }}
                        />
                    )
                }
            />
        ),
    },
    {
        field: "vehiclePlate",
        align: "left",
        width: 150,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Placa"}
                icon={<AbcOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.vehiclePlate ?? ""}
            />
        ),
    },
    {
        field: "checkTypeName",
        align: "left",
        width: 200,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Tipo"}
                icon={<AbcOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.checkTypeName || ""}
            />
        ),
    },
    {
        // A API já devolve a data formatada e a lista ordenada da mais recente para a mais antiga.
        field: "createdAt",
        align: "left",
        width: 180,
        editable: false,
        sortable: false,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Data"}
                icon={<CalendarMonthOutlined style={{ height: 24, width: 24, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.createdAt || ""}
            />
        ),
    },
    {
        field: "checkStatusName",
        align: "left",
        width: 150,
        headerClassName: "last-column",
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Status"}
                icon={<AbcOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.checkStatusName || ""}
            />
        ),
    },
];

const rowsOptions = (
    list: Array<any>,
    openDetails?: SetterOrUpdater<boolean>
): Array<any> => {
    const result = [...list];
    return result.map((item) => ({ ...item, openDetails }));
};

const CheckListComponent = () => {
    // atoms
    const getCurrentUser = useRecoilValue<UserType>(userAtom);

    // funcionalities states
    const [isOnline, setIsOnline] = useState<boolean>(true);
    const [isOpenDetails, setIsOpenDetails] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [validationText, setTextValidation] = useState<string>("");
    const [isFieldsValid, setFieldsIsValid] = useState<boolean>(true);
    const [statusMessage, setStatusMessage] = useState<"warn" | "success" | "info" | "error" | undefined>("warn");
    const [isToastVisible, setIsToastVisible] = useState(false);
    const [inEdit, setInEdit] = useState<boolean>(false);
    const [inInsert, setInInsert] = useState<boolean>(false);
    const [query, setQuery] = useState<string>("");
    const [filteredList, setFilteredList] = useState<Array<any>>([]);

    const [isLastPage, setIsLastPage] = useState<boolean>(true);
    const [numberOfElementsPerPage, setNumberOfElementsPerPage] = useState<number>(0);
    const [numberOfElements, setNumberOfElements] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(0);

    const [report, setReport] = useState<ArrayBuffer>(new ArrayBuffer(0));
    const [exportType, setExportType] = useState<string>("");

    // states
    const [customersList, setCustomersList] = useState<Array<CustomerListType>>([]);
    const [activeStep, setActiveStep] = useState<number>(0);

    const [customer, setCustomer] = useState<CustomerListType>(customerDefault);

    const [vehicleList, setVehicleList] = useState<Array<VehicleListType>>([]);
    const [selectedVehicle, setSelectedVehicle] = useState<VehicleListType | null>({ id: -1 } as any);

    const [checkListFiles, setCheckListFiles] = useState<Array<string | null | undefined | File | any>>([]);
    const [currentCheckListFile, setCurrentCheckListFile] = useState<string | null | undefined | File | any>(null);

    const [selectedChecklist, setSelectedCheckList] = useState<any>({
        id: -1,
        activated: true,
    });

    const [checkListTypesList, setCheckListTypesList] = useState<Array<any>>([]);
    const [checkListType, setCheckListType] = useState<any | null>(null);
    const [checkListsList, setCheckListsList] = useState<Array<any>>([]);
    const [open, setOpen] = useState<boolean>(false);

    const [form, setForm] = useState({
        checkTypeId: "",
        driverId: "",
        vehicleId: "",
        odometer: 0,

        // segurança
        seatBeltOk: true,
        brakesOk: true,
        handBrakeOk: true,
        hornOk: true,
        brakeLightOk: true,
        turnSignalsOk: true,
        headlightsOk: true,
        highBeamOk: true,
        hazardLightsOk: true,
        mirrorsOk: true,
        reverseLightOk: true,
        auxiliaryReverseLightOk: true,
        suspensionSystemOk: true,
        fireExtinguisherOk: true,
        beaconLightOk: true,
        reverseAlarmOk: true,
        reflectiveStripsOk: true,
        rearWindowGuardOk: true,

        // condições
        tiresOk: true,
        spareTireOk: true,
        hubcapsOk: true,
        bodyworkOk: true,
        windshieldOk: true,
        wipersOk: true,
        oilLevelOk: true,
        coolantLevelOk: true,
        batteryOk: true,
        windshieldWaterOk: true,
        brakeOilOk: true,
        fuelLevelOk: true,
        toolKitOk: true,
        smokeTestOk: true,

        // conforto
        airConditioningOk: true,
        dashboardOk: true,
        doorLocksOk: true,
        windowsOk: true,
        luggageCompartmentOk: true,

        // rastreamento
        trackerOk: true,
        gpsSignalOk: true,
        individualTelemetryOk: true,
        notes: ""
    });

    // cookies
    const [cookies] = useCookies(["selectedParameters", "token"]);

    // refs
    const toastRef = useRef<Toast>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const toastModalRef = useRef<Toast>(null);
    const anchorRef = useRef<any>(null);

    const currentParameters: SelectedParametersType = useMemo(() => cookies.selectedParameters, [cookies.selectedParameters]);
    const location = useLocation();
    const isMobile = useMediaQuery("(max-width:650px)");

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleClose = useCallback(() => {
        // estados de UI
        setLoading(false);
        setStatusMessage("warn");
        setIsToastVisible(false);
        setFieldsIsValid(true);
        setTextValidation("");
        setActiveStep(0);
        setIsOpenDetails(false);

        // seleção principal
        // setCustomer(customerDefault);
        // setSelectedVehicle({ id: -1 } as any);
        setCheckListType(null);
        setSelectedCheckList({
            id: -1,
            activated: true
        });

        // anexos
        setCheckListFiles([]);
        setCurrentCheckListFile(null);

        // formulário (volta tudo para o padrão true)
        setForm({
            checkTypeId: "",
            driverId: "",
            vehicleId: "",
            odometer: 0,

            // segurança
            seatBeltOk: true,
            brakesOk: true,
            handBrakeOk: true,
            hornOk: true,
            brakeLightOk: true,
            turnSignalsOk: true,
            headlightsOk: true,
            highBeamOk: true,
            hazardLightsOk: true,
            mirrorsOk: true,
            reverseLightOk: true,
            auxiliaryReverseLightOk: true,
            suspensionSystemOk: true,
            fireExtinguisherOk: true,
            beaconLightOk: true,
            reverseAlarmOk: true,
            reflectiveStripsOk: true,
            rearWindowGuardOk: true,

            // condições
            tiresOk: true,
            spareTireOk: true,
            hubcapsOk: true,
            bodyworkOk: true,
            windshieldOk: true,
            wipersOk: true,
            oilLevelOk: true,
            coolantLevelOk: true,
            batteryOk: true,
            windshieldWaterOk: true,
            brakeOilOk: true,
            fuelLevelOk: true,
            toolKitOk: true,
            smokeTestOk: true,

            // conforto
            airConditioningOk: true,
            dashboardOk: true,
            doorLocksOk: true,
            windowsOk: true,
            luggageCompartmentOk: true,

            // rastreamento
            trackerOk: true,
            gpsSignalOk: true,
            individualTelemetryOk: true,
            notes: ""
        });
    }, []);

    const addItens = useCallback(() => {
        if (currentCheckListFile) {
            const reader = new FileReader();
            reader.readAsDataURL(currentCheckListFile[0]);
            reader.onloadend = () => {
                setCheckListFiles((prev) => [
                    ...prev,
                    {
                        file: reader.result as string,
                        type: currentCheckListFile[0].type.substring(0, 5),
                        id: Math.random(),
                    },
                ]);
            };
        } else {
            setCurrentCheckListFile("");
        }
    }, [currentCheckListFile]);

    useEffect(() => {
        addItens();
    }, [addItens]);

    useEffect(() => {
        if (validationText && !isFieldsValid && !isToastVisible) {
            setToastRefToOpen(
                toastRef,
                validationText,
                "Atenção!",
                statusMessage,
                undefined,
                3000,
                false
            );
        }
    }, [
        isOpenDetails,
        validationText,
        isFieldsValid,
        statusMessage,
        isToastVisible,
        toastRef
    ]);

    useEffect(() => {
        if (report.byteLength > 1) {
            const typeExport =
                exportType === "pdf"
                    ? "application/pdf"
                    : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            const file = new Blob([report], { type: typeExport });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            setReport(new ArrayBuffer(0));
        }
    }, [report, exportType]);

    const getCustomersList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        try {
            const response = await customerFindAllListResponse(token, currentParameters.customer.id);
            setCustomersList(response.data);
        } catch (error) {
            console.log(error);
            setCustomersList([]);
        }
    }, [cookies.token, currentParameters]);

    useEffect(() => {
        if (getCurrentUser.configs.isManager) {
            getCustomersList();
        }
    }, [getCustomersList, getCurrentUser.configs.isManager]);

    const getAllVehicles = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const customerId = !getCurrentUser.configs.isManager ? currentParameters?.customer.id : customer.id;
        const departmentId = -1;
        try {
            const { data } =
                await findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdListResponse(
                    token,
                    customerId,
                    departmentId,
                    true
                );
            setVehicleList(data);
        } catch (error: any) {
            console.log(error);
            setVehicleList([]);
        }
    }, [
        getCurrentUser?.configs.isManager,
        currentParameters?.customer.id,
        customer.id,
        cookies.token
    ]);

    useEffect(() => {
        getAllVehicles();
    }, [getAllVehicles]);

    const getAllCheckTypesList = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        try {
            const { data } = await checkListTypesFindAllByActivated(token, "activated");
            if (data.length > 0) {
                setCheckListTypesList(data);
            }
        } catch (error: any) {
            console.log(error);
            setCheckListTypesList([]);
        }
    }, [cookies.token]);

    useEffect(() => {
        getAllCheckTypesList();
    }, [
        getAllCheckTypesList
    ]);

    const getAllCheckLists = useCallback(
        async (status: string = "activated", page: number = 0, size: number = 100) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            const customerId = getCurrentUser.configs.isManager ? customer.id : currentParameters?.customer.id;

            setLoading(true);
            try {
                const { data } = await checklistsFindAllByActivated(token, customerId, selectedVehicle?.id!!, status, page, size);
                setCheckListsList(data.content);
                setIsLastPage(data.last);
                setNumberOfElementsPerPage(data.numberOfElements);
                setPageNumber(data.pageable.pageNumber);

                if (data.first) {
                    setNumberOfElements(data.totalElements);
                }
            } catch (error: any) {
                console.log(error);
                setCheckListsList([]);
            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 2000);
            }
        },
        [cookies.token, currentParameters?.customer.id, customer.id, getCurrentUser.configs.isManager, selectedVehicle?.id]
    );

    useEffect(() => {
        if (selectedVehicle?.id!! > -1) {
            getAllCheckLists();
        }
    }, [getAllCheckLists, selectedVehicle?.id]);

    const onSave = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const customerData = getCurrentUser.configs.isManager ? customer : currentParameters.customer;

        setLoading(true);

        const data: CheckListRequestType = {
            id: -1,
            checkTypeId: checkListType?.id,
            driverId: Number(form.driverId),
            vehicleId: Number(selectedVehicle?.id),
            odometer: form.odometer,

            // segurança
            seatBeltOk: form.seatBeltOk,
            brakesOk: form.brakesOk,
            handBrakeOk: form.handBrakeOk,
            hornOk: form.hornOk,
            brakeLightOk: form.brakeLightOk,
            turnSignalsOk: form.turnSignalsOk,
            headlightsOk: form.headlightsOk,
            highBeamOk: form.highBeamOk,
            hazardLightsOk: form.hazardLightsOk,
            mirrorsOk: form.mirrorsOk,
            reverseLightOk: form.reverseLightOk,
            auxiliaryReverseLightOk: form.auxiliaryReverseLightOk,
            suspensionSystemOk: form.suspensionSystemOk,
            fireExtinguisherOk: form.fireExtinguisherOk,
            beaconLightOk: form.beaconLightOk,
            reverseAlarmOk: form.reverseAlarmOk,
            reflectiveStripsOk: form.reflectiveStripsOk,
            rearWindowGuardOk: form.rearWindowGuardOk,

            // condições
            tiresOk: form.tiresOk,
            spareTireOk: form.spareTireOk,
            hubcapsOk: form.hubcapsOk,
            bodyworkOk: form.bodyworkOk,
            windshieldOk: form.windshieldOk,
            wipersOk: form.wipersOk,
            oilLevelOk: form.oilLevelOk,
            coolantLevelOk: form.coolantLevelOk,
            batteryOk: form.batteryOk,
            windshieldWaterOk: form.windshieldWaterOk,
            brakeOilOk: form.brakeOilOk,
            fuelLevelOk: form.fuelLevelOk,
            toolKitOk: form.toolKitOk,
            smokeTestOk: form.smokeTestOk,

            // conforto
            airConditioningOk: form.airConditioningOk,
            dashboardOk: form.dashboardOk,
            doorLocksOk: form.doorLocksOk,
            windowsOk: form.windowsOk,
            luggageCompartmentOk: form.luggageCompartmentOk,

            // rastreamento
            trackerOk: form.trackerOk,
            gpsSignalOk: form.gpsSignalOk,
            individualTelemetryOk: form.individualTelemetryOk,

            notes: form.notes,
            files: checkListFiles.map((it) => it.file),
            customerId: customerData?.id,
            customerReducedName: customerData?.reducedName ?? ""
        };

        // validação mínima
        if (!data.checkTypeId || !data.vehicleId) {
            setTextValidation(
                "Todos os campos obrigatórios devem ser preenchidos."
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        try {
            await checkListSaveByVehicle(token, data);
            setTextValidation("Checklist salvo com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);

            setTimeout(() => {
                handleClose();
                getAllCheckLists();
            }, 3000);

        } catch (error: any) {
            setLoading(false);

            const { data } = error.response || {};
            if (data?.reason) {
                const errors = data.reason.split(".");
                errors.forEach((message: string, index: number) => {
                    if (index === 0) {
                        setFieldsIsValid(false);
                        setStatusMessage("warn");
                        setTextValidation(message);
                    }
                });
            } else {
                setStatusMessage("error");
                setTextValidation("Erro ao salvar checklist.");
            }
        }
    }, [
        cookies.token,
        checkListType?.id,
        selectedVehicle?.id,
        currentParameters.customer,
        getCurrentUser.configs.isManager,
        customer,
        form,
        checkListFiles,
        handleClose,
        getAllCheckLists
    ]);

    const getLastReport = useCallback(
        async (type: string) => {
            setLoading(true);
            let dataBuffer = new ArrayBuffer(0);
            const customerData = getCurrentUser.configs.isManager ? customer : currentParameters.customer;

            let reportType = type;
            let isSimpleType = false;
            if (type.includes("simple")) {
                reportType = reportType.split(" ")[0];
                isSimpleType = true;
            };

            try {
                const { data }: any =
                    await checklistFindLastExportResponse(cookies.token, customerData?.id, selectedVehicle?.id!!, reportType, isSimpleType);

                if ((data as ArrayBuffer).byteLength === 0) {
                    setTextValidation("Nenhum dado para mostrar no relatório.");
                    setStatusMessage("warn");
                    setFieldsIsValid(false);
                } else {
                    setTextValidation("Relatório gerado com sucesso.");
                    setStatusMessage("success");
                    setFieldsIsValid(false);
                    dataBuffer = data;
                }
            } catch (error: any) {
                const { data } = error.response;

                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(data.reason);
            } finally {
                setTimeout(() => {
                    handleClose();
                    setReport(dataBuffer);
                    setExportType(type);
                }, 3000);
            }
        },
        [cookies.token, selectedVehicle?.id, handleClose, currentParameters.customer, customer, getCurrentUser.configs.isManager]
    );

    const getReport = useCallback(
        async (type: string) => {
            setLoading(true);
            let dataBuffer = new ArrayBuffer(0);
            const customerData = getCurrentUser.configs.isManager ? customer : currentParameters.customer;

            let reportType = type;
            let isSimpleType = false;
            if (type.includes("simple")) {
                reportType = reportType.split(" ")[0];
                isSimpleType = true;
            };

            try {
                const { data }: any =
                    await checklistFindByIdExportResponse(cookies.token, customerData?.id, selectedVehicle?.id!!, selectedChecklist.id, reportType, isSimpleType);

                if ((data as ArrayBuffer).byteLength === 0) {
                    setTextValidation("Nenhum dado para mostrar no relatório.");
                    setStatusMessage("warn");
                    setFieldsIsValid(false);
                } else {
                    setTextValidation("Relatório gerado com sucesso.");
                    setStatusMessage("success");
                    setFieldsIsValid(false);
                    dataBuffer = data;
                }
            } catch (error: any) {
                const { data } = error.response;

                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(data.reason);
            } finally {
                setTimeout(() => {
                    handleClose();
                    setReport(dataBuffer);
                    setExportType(type);
                }, 3000);
            }
        },
        [cookies.token, selectedVehicle?.id, handleClose, currentParameters.customer, customer, getCurrentUser.configs.isManager, selectedChecklist.id]
    );

    const toggle = useCallback((key: keyof typeof form) =>
        (_: any, checked: boolean) =>
            setForm({ ...form, [key]: checked }), [form]);

    const onHandleFullScreen = (fileUrl: string, fileName: string) => {
        if (!document.fullscreenElement) {
            const element = document.createElement("img");
            element.className = "img-anexo";
            element.id = fileName;
            element.src = fileUrl;
            element.style.objectFit = "contain";
            document.body.appendChild(element);

            const img = document.querySelector(".img-anexo");
            img?.requestFullscreen().catch((err: any) => {
                console.error("Erro ao entrar em modo fullscreen:", err);
            });

            img?.addEventListener("fullscreenchange", () => {
                if (!document.fullscreenElement) {
                    document.body.removeChild(img);
                }
            });
        } else {
            document.exitFullscreen();
        }
    };

    const onHandleDownload = (fileUrl: string, fileName: string) => {
        const link = document.createElement("a");
        link.href = fileUrl;
        
        let extension = "";
        if (fileUrl.startsWith("data:")) {
            const mime = fileUrl.split(";")[0].split(":")[1];
            if (mime && mime.includes("/")) {
                extension = "." + mime.split("/")[1];
            }
        }
        
        link.download = fileName.includes(".") 
            ? fileName 
            : `${fileName || "download"}${extension || ".png"}`;
            
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const checklistLetter = useMemo(() => {
        if (!selectedChecklist || !selectedChecklist.id) return <></>;

        const legendTemplate = (
            <Box className="flex" style={{ border: "none" }}>
                <Typography className="font-bold">
                    Checklist #{selectedChecklist.id}
                </Typography>
            </Box>
        );

        const renderBooleanChip = (label: string, value: boolean) => (
            <Chip
                size="small"
                className="tw-font-prometo tw-font-bold"
                sx={{
                    color: value ? "#166534" : "#991b1b",
                    backgroundColor: value ? "#dcfce7" : "#fee2e2",
                    border: `1px solid ${value ? "#86efac" : "#fecaca"}`,
                    fontWeight: 700,
                }}
                clickable={false}
                label={`${label}: ${value ? "OK" : "Com defeito"}`}
            />
        );

        return (
            <Box className="checklist-details tw-flex tw-max-h-[calc(100dvh-24px)] tw-w-full tw-flex-col tw-overflow-hidden tw-bg-white dark:tw-bg-slate-900">
                <Box
                    className="tw-flex tw-flex-none tw-items-center tw-justify-between tw-gap-3 tw-bg-gtr-sidebar tw-px-4 tw-py-3 tw-text-white sm:tw-px-5"
                    sx={{
                        px: { xs: 2, sm: 2.5 },
                        py: 1.5,
                        bgcolor: "#003f4a",
                        backgroundImage: "linear-gradient(to right, #006C77, #09414A)",
                        color: "common.white",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Box>
                        <Typography variant="body1">Checagem do veículo: {`${selectedChecklist.vehicleName} - ${selectedChecklist.vehiclePlate}`}</Typography>
                        <Typography variant="caption">{""}</Typography>
                    </Box>
                    {handleClose &&
                        <Box className="tw-flex tw-flex-none tw-items-center tw-gap-1">
                            <Tooltip title="Exportar checagem" arrow>
                                <IconButton
                                    ref={(ref) => anchorRef.current = ref}
                                    className="refresh-button-icon"
                                    title="Exportar"
                                    onClick={() => setOpen(true)}
                                    aria-label="Exportar checagem"
                                    sx={{ color: "#fff", width: 40, height: 40, borderRadius: 2, "&:hover": { backgroundColor: "rgba(255,255,255,0.12)" } }}
                                >
                                    <PrintOutlined style={{ color: "#ffff" }} />
                                </IconButton>
                            </Tooltip>

                                <Menu
                                    open={open}
                                    anchorEl={() => anchorRef.current as HTMLElement}
                                    onClose={() => { setOpen(false) }}
                                >
                                    {items.map((option: MenuIt) => (
                                        <MenuItem key={option?.id} onClick={(e: any) => {
                                            setOpen(false);
                                            getReport(option.label!!.toLocaleLowerCase())
                                        }}>
                                            {` ${option.label}`}
                                        </MenuItem>
                                    ))}
                                </Menu>
                            <Tooltip title="Fechar" arrow>
                                <IconButton aria-label="Fechar checagem" onClick={handleClose} sx={{ color: "#fff", width: 40, height: 40, borderRadius: 2, "&:hover": { backgroundColor: "rgba(255,255,255,0.12)" } }}>
                                    <GridCloseIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>}
                </Box>
                <Box className="tw-flex-1 tw-overflow-y-auto tw-p-3 sm:tw-p-4" sx={{ scrollbarWidth: "thin", scrollbarColor: "#94a3b8 transparent" }}>
                {/* DESCRIÇÃO / HEADER */}
                <Box
                    className="col-md-12 tw-mb-3"
                    sx={{
                        margin: "0 0 12px",
                        "& .p-fieldset-legend": { border: "none" },
                        "& .p-fieldset": { borderColor: "#e2e8f0", borderRadius: "12px" },
                        "& .p-fieldset-content": { padding: "12px 16px" },
                    }}
                >
                    <Fieldset
                        legend={legendTemplate}
                        style={{ minHeight: 82, border: "1px solid #e2e8f0" }}
                    >
                        <Typography>
                            {selectedChecklist.notes || "Sem observações"}
                        </Typography>
                    </Fieldset>
                </Box>

                {/* IDENTIFICAÇÃO */}
                <Box
                    className="col-sm-12 col-md-12 tw-flex tw-flex-wrap tw-gap-2"
                    style={{
                        display: "flex",
                        justifyContent: "start",
                        marginBottom: "12px",
                        flexWrap: "wrap",
                    }}
                >
                    {selectedChecklist.driverName && <Chip
                        size="small"
                        style={{ marginRight: 0 }}
                        label={`Motorista: ${selectedChecklist.driverName}`}
                    />}
                </Box>

                {/* STATUS / META */}
                <Box className="col-md-12 tw-mb-3 tw-flex tw-flex-wrap tw-gap-2" style={{ marginBottom: 12 }}>
                    {/*<Chip
                        style={{
                            color: "black",
                            margin: 5,
                            background: selectedChecklist.activated
                                ? "#81c784"
                                : "#dc3545",
                            fontWeight: "bolder",
                        }}
                        label={selectedChecklist.activated ? "Ativo" : "Inativo"}
                    />*/}

                    <Chip
                        size="small"
                        style={{
                            color: "black",
                            margin: 0,
                            background: "#64b5f6",
                            fontWeight: "bolder",
                        }}
                        label={getChecklistTypeByValue(selectedChecklist.checkTypeId)?.nameDesc ?? ""}
                    />

                    <Chip
                        size="small"
                        style={{
                            color: "black",
                            margin: 0,
                            background: selectedChecklist.checkStatusId === CHECKLIST_STATUS.FIT.value
                                ? "#81c784"
                                : selectedChecklist.checkStatusId === CHECKLIST_STATUS.ATTENTION.value ? "#f3bc06ff" : "#dc3545",
                            fontWeight: "bolder",
                        }}
                        label={selectedChecklist.checkStatusName}
                    />
                    <Chip
                        size="small"
                        style={{
                            color: "black",
                            margin: 0,
                            background: selectedChecklist.checkStatusId === CHECKLIST_STATUS.FIT.value
                                ? "#81c784"
                                : selectedChecklist.checkStatusId === CHECKLIST_STATUS.ATTENTION.value ? "#f3bc06ff" : "#dc3545",
                            fontWeight: "bolder",
                        }}
                        label={selectedChecklist?.checkStatusDescription ?? ""}
                    />
                    {/* <Chip
                        style={{
                            color: "black",
                            marginRight: 5,
                            background: "#90caf9",
                            fontWeight: "bolder",
                        }}
                        label={`Odômetro: ${selectedChecklist.odometer}`}
                    /> */}
                </Box>

                <Box sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "repeat(2, minmax(0, 1fr))" },
                    gap: 1.5,

                    /* Firefox */
                    scrollbarWidth: "thin",
                    scrollbarColor: "#c1c1c1 transparent",

                    /* Chrome / Edge / Safari */
                    "&::-webkit-scrollbar": {
                        width: "5px",
                    },
                    "&::-webkit-scrollbar-track": {
                        background: "transparent",
                    },
                    "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#c1c1c1",
                        borderRadius: "8px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                        cursor: "pointer",
                        backgroundColor: "#9e9e9e",
                    }
                }}>
                    {/* ITENS DE SEGURANÇA */}
                    <Box className="checklist-section col-md-12 tw-rounded-xl tw-border-0 tw-bg-slate-50/60 tw-p-3 dark:tw-bg-slate-950" style={{ marginBottom: 0 }}>
                        <Typography fontWeight="bolder">Itens de segurança</Typography>

                        <Box mt={1} className="tw-flex tw-flex-wrap tw-gap-2">
                            {renderBooleanChip("Cinto", selectedChecklist.seatBeltOk)}
                            {renderBooleanChip("Freios", selectedChecklist.brakesOk)}
                            {renderBooleanChip("Freio de mão", selectedChecklist.handBrakeOk)}
                            {renderBooleanChip("Buzina", selectedChecklist.hornOk)}
                            {renderBooleanChip("Luz de freio", selectedChecklist.brakeLightOk)}
                            {renderBooleanChip("Setas", selectedChecklist.turnSignalsOk)}
                            {renderBooleanChip("Farol baixo", selectedChecklist.headlightsOk)}
                            {renderBooleanChip("Farol alto", selectedChecklist.highBeamOk)}
                            {renderBooleanChip("Pisca alerta", selectedChecklist.hazardLightsOk)}
                            {renderBooleanChip("Retrovisores", selectedChecklist.mirrorsOk)}
                            {renderBooleanChip("Luz de ré", selectedChecklist.reverseLightOk)}
                            {renderBooleanChip("Farol auxiliar de ré", selectedChecklist.auxiliaryReverseLightOk)}
                            {renderBooleanChip("Sistema de suspensão", selectedChecklist.suspensionSystemOk)}
                            {renderBooleanChip("Extintor de incêndio (2kg)", selectedChecklist.fireExtinguisherOk)}
                            {renderBooleanChip("Giroflex", selectedChecklist.beaconLightOk)}
                            {renderBooleanChip("Alarme de ré", selectedChecklist.reverseAlarmOk)}
                            {renderBooleanChip("Faixas refletivas", selectedChecklist.reflectiveStripsOk)}
                            {renderBooleanChip("Grade de proteção do vidro traseiro", selectedChecklist.rearWindowGuardOk)}
                        </Box>
                    </Box>

                    {/* CONDIÇÕES DO VEÍCULO */}
                    <Box className="checklist-section col-md-12 tw-rounded-xl tw-border-0 tw-bg-slate-50/60 tw-p-3 dark:tw-bg-slate-950" style={{ marginBottom: 0 }}>
                        <Typography fontWeight="bolder">Condições do veículo</Typography>

                        <Box mt={1} className="tw-flex tw-flex-wrap tw-gap-2">
                            {renderBooleanChip("Pneus", selectedChecklist.tiresOk)}
                            {renderBooleanChip("Estepe", selectedChecklist.spareTireOk)}
                            {renderBooleanChip("Calotas", selectedChecklist.hubcapsOk)}
                            {renderBooleanChip("Lataria", selectedChecklist.bodyworkOk)}
                            {renderBooleanChip("Para-brisa", selectedChecklist.windshieldOk)}
                            {renderBooleanChip("Limpador", selectedChecklist.wipersOk)}
                            {renderBooleanChip("Bateria", selectedChecklist.batteryOk)}
                            {renderBooleanChip("Óleo", selectedChecklist.oilLevelOk)}
                            {renderBooleanChip("Água", selectedChecklist.coolantLevelOk)}
                            {renderBooleanChip("Água do para-brisa", selectedChecklist.windshieldWaterOk)}
                            {renderBooleanChip("Óleo do freio", selectedChecklist.brakeOilOk)}
                            {renderBooleanChip("Combustível", selectedChecklist.fuelLevelOk)}
                            {renderBooleanChip("Chave de roda, triângulo e macaco", selectedChecklist.toolKitOk)}
                            {renderBooleanChip("Teste de fumaça preta", selectedChecklist.smokeTestOk)}
                        </Box>
                    </Box>

                    {/* CONDIÇÕES DO VEÍCULO */}
                    <Box className="checklist-section col-md-12 tw-rounded-xl tw-border-0 tw-bg-slate-50/60 tw-p-3 dark:tw-bg-slate-950" style={{ marginBottom: 0 }}>
                        <Typography fontWeight="bolder">Conforto e operacional</Typography>
                        <Box mt={1} className="tw-flex tw-flex-wrap tw-gap-2">
                            {renderBooleanChip("Ar-condicionado", selectedChecklist.airConditioningOk)}
                            {renderBooleanChip("Painel", selectedChecklist.dashboardOk)}
                            {renderBooleanChip("Travas", selectedChecklist.doorLocksOk)}
                            {renderBooleanChip("Vidros", selectedChecklist.windowsOk)}
                            {renderBooleanChip("Bagageiro", selectedChecklist.luggageCompartmentOk)}
                        </Box>
                    </Box>

                    {/* RASTREAMENTO (opcional) */}
                    {selectedChecklist.trackerOk !== undefined && (
                        <Box className="checklist-section col-md-12 tw-rounded-xl tw-border-0 tw-bg-slate-50/60 tw-p-3 dark:tw-bg-slate-950" style={{ marginBottom: 0 }}>
                            <Typography fontWeight="bolder">Rastreamento</Typography>

                            <Box mt={1} className="tw-flex tw-flex-wrap tw-gap-2">
                                {renderBooleanChip("Rastreador", selectedChecklist.trackerOk)}
                                {renderBooleanChip("GPS", selectedChecklist.gpsSignalOk)}
                                {renderBooleanChip("Telemetria individual", selectedChecklist.individualTelemetryOk)}
                            </Box>
                        </Box>
                    )}

                    {/* ANEXOS */}
                    <Box className="col-sm-12 col-md-7 tw-flex tw-items-center" sx={{ gridColumn: "1 / -1" }}>
                        <Typography variant="body1" sx={{ fontWeight: "bolder" }}>
                            Anexos
                        </Typography>
                    </Box>

                    <Box className="col-md-12" style={{ marginBottom: 0 }}>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                            {selectedChecklist.files && selectedChecklist.files.length > 0 ? (
                                selectedChecklist.files.map((item: any, index: number) => (
                                    <Card
                                        key={index}
                                        className="tw-overflow-hidden tw-rounded-xl tw-border-0 tw-bg-white tw-shadow-none dark:tw-bg-slate-800"
                                        sx={{ padding: 0, margin: 0, borderRadius: 3 }}
                                    >
                                        <img
                                            src={item.file}
                                            alt="anexo"
                                            style={{
                                                width: 128,
                                                height: 112,
                                                objectFit: "cover",
                                                borderRadius: 0,
                                                margin: 0,
                                            }}
                                        />
                                        <CardActions
                                            style={{ display: "flex", justifyContent: "center" }}
                                        >
                                            <DownloadOutlined
                                                onClick={() => onHandleDownload(item?.file, "anexo" + (index + 1))}
                                                style={{
                                                    height: 24,
                                                    width: 24,
                                                    fill: "#00B700",
                                                    cursor: "pointer",
                                                }}
                                            />

                                            <FullscreenOutlined
                                                onClick={() => onHandleFullScreen(item?.file, "anexo" + (index + 1))}
                                                style={{
                                                    height: 24,
                                                    width: 24,
                                                    fill: "blue",
                                                    cursor: "pointer",
                                                }}
                                            />
                                        </CardActions>
                                    </Card>
                                ))
                            ) : (
                                <Typography>Nenhum anexo</Typography>
                            )}
                        </Box>
                    </Box>
                </Box>
                </Box>
            </Box>
        );
    }, [selectedChecklist, handleClose, open, getReport]);

    const steps = useMemo(() => [
        {
            label: "Identificação",
            item: (
                <>
                    <Paper className="checklist-form-surface trv-container tw-rounded-xl tw-border-0 tw-bg-white tw-shadow-none dark:tw-bg-slate-900" elevation={0} sx={style}>
                        <Box className="col-md-12" style={{ marginBottom: 20 }}>
                            <Autocomplete
                                id="chip-label-select-customer"
                                className="input-select-customer"
                                style={{
                                    width: "100%",
                                    minHeight: "56px",
                                    height: "56px",
                                    backgroundColor: "#ffffff29",
                                    borderColor: "lightgray",
                                }}
                                options={checkListTypesList}
                                value={checkListType}
                                onChange={(_, option) => {
                                    setCheckListType(option ?? null);
                                }}
                                disabled={false}
                                getOptionLabel={(option) => `${getChecklistTypeByValue(option.id)?.nameDesc ?? ""}`}
                                noOptionsText={"Nada encontrado"}
                                ListboxProps={{ style: { maxHeight: "min(40dvh, 280px)", overflowY: "auto", scrollbarWidth: "thin" } }}
                                renderInput={(params) => (
                                    <>
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex" }}
                                        >
                                            <InputLabel
                                                id="country-label"
                                                required
                                                disabled={false}
                                                style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                shrink
                                            >
                                                Tipo de Checagem
                                            </InputLabel>
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                placeholder="selecione um tipo"
                                                autoComplete="off"
                                                required
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    notched: true,
                                                    label: "Tipo de Checagem",
                                                    classes: {
                                                        notchedOutline: "custom-notch",
                                                    },
                                                }}
                                            />
                                        </FormControl>
                                    </>
                                )}
                            />
                        </Box>
                    </Paper>
                </>
            ),
        },
        {
            label: "Checagem",
            item: (
                <Paper className="checklist-form-surface trv-container tw-m-0 tw-rounded-xl tw-border-0 tw-bg-white tw-shadow-none dark:tw-bg-slate-900" elevation={0} sx={style}>
                    {[
                        {
                            title: "Itens de segurança",
                            items: [
                                ["Cinto de segurança", "seatBeltOk"],
                                ["Freios", "brakesOk"],
                                ["Freio de mão", "handBrakeOk"],
                                ["Buzina", "hornOk"],
                                ["Luz de freio", "brakeLightOk"],
                                ["Setas", "turnSignalsOk"],
                                ["Farol baixo", "headlightsOk"],
                                ["Farol alto", "highBeamOk"],
                                ["Pisca alerta", "hazardLightsOk"],
                                ["Retrovisores", "mirrorsOk"],
                                ["Luz de ré", "reverseLightOk"],
                                ["Farol auxiliar de ré", "auxiliaryReverseLightOk"],
                                ["Sistema de suspensão", "suspensionSystemOk"],
                                ["Extintor de incêndio (2kg)", "fireExtinguisherOk"],
                                ["Giroflex", "beaconLightOk"],
                                ["Alarme de ré", "reverseAlarmOk"],
                                ["Faixas refletivas", "reflectiveStripsOk"],
                                ["Grade de proteção do vidro traseiro", "rearWindowGuardOk"]
                            ]
                        },
                        {
                            title: "Condições do veículo",
                            items: [
                                ["Pneus", "tiresOk"],
                                ["Estepe", "spareTireOk"],
                                ["Calotas", "hubcapsOk"],
                                ["Lataria", "bodyworkOk"],
                                ["Para-brisa", "windshieldOk"],
                                ["Limpador", "wipersOk"],
                                ["Óleo", "oilLevelOk"],
                                ["Água", "coolantLevelOk"],
                                ["Bateria", "batteryOk"],
                                ["Água do para-brisa", "windshieldWaterOk"],
                                ["Óleo do freio", "brakeOilOk"],
                                ["Combustível", "fuelLevelOk"],
                                ["Chave de roda, triângulo e macaco", "toolKitOk"],
                                ["Teste de fumaça preta", "smokeTestOk"]
                            ]
                        },
                        {
                            title: "Conforto e operacional",
                            items: [
                                ["Ar-condicionado", "airConditioningOk"],
                                ["Painel", "dashboardOk"],
                                ["Travas", "doorLocksOk"],
                                ["Vidros", "windowsOk"],
                                ["Bagageiro", "luggageCompartmentOk"]
                            ]
                        },
                        ...(getCurrentUser.configs.isManager
                            ? [
                                {
                                    title: "Rastreamento",
                                    items: [
                                        ["Rastreador", "trackerOk"],
                                        ["Sinal GPS", "gpsSignalOk"],
                                        ["Telemetria individual", "individualTelemetryOk"]
                                    ]
                                }
                            ]
                            : [])
                    ].map((section) => (
                        <Box mt={1} key={section.title} className="tw-min-w-0">
                            <Typography fontWeight="bold" marginBottom={"5px"}>{section.title}</Typography>
                            <Box className="tw-grid tw-grid-cols-[repeat(auto-fit,minmax(min(100%,240px),1fr))] tw-gap-2">
                                {section.items.map(([label, key]) => (
                                    <Box
                                        key={key}
                                        className="tw-flex tw-min-w-0 tw-items-center tw-justify-between tw-gap-3 tw-rounded-lg tw-bg-slate-50 tw-px-3 tw-py-2 dark:tw-bg-slate-800"
                                    >
                                        <Typography sx={{ margin: 0, minWidth: 0, flex: 1, color: "inherit", wordBreak: "normal", overflowWrap: "normal" }}>{label}</Typography>
                                        <FormControlLabel
                                            sx={{ margin: 0, flexShrink: 0, gap: 0.75, whiteSpace: "nowrap", minHeight: { xs: 44, sm: 0 } }}
                                            control={
                                                <IOSSwitch
                                                    sx={{ flexShrink: 0 }}
                                                    inputProps={{ "aria-label": label }}
                                                    checked={(form as any)[key]}
                                                    onChange={toggle(key as any)}
                                                />
                                            }
                                            label={<Typography>{"Ok"}</Typography>}
                                        />
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    ))}

                    {/* ANEXOS */}
                    <Box className="tw-flex tw-min-w-0 tw-items-center">
                        <Typography variant="body1" sx={{ fontWeight: "bolder", marginBottom: "5px" }}>
                            Anexos(Opcional)
                        </Typography>
                    </Box>

                    <Box className="col-md-12" style={{ marginBottom: 20 }}>
                        <Box className="attachment-dropzone" sx={{ paddingTop: 2, display: "flex", flexWrap: "wrap", gap: 1, minWidth: 0 }}>
                            <input
                                type="file"
                                style={{ display: "none" }}
                                ref={fileInputRef}
                                accept="image/*"
                                onChange={(
                                    event: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                    const target = event.target;
                                    const file = target?.files;
                                    if (
                                        file &&
                                        file[0].type.substring(0, 5) === "image"
                                    ) {
                                        setCurrentCheckListFile(file);
                                    } else {
                                        setCurrentCheckListFile(null);
                                    }
                                }}
                            />
                            {checkListFiles && checkListFiles?.length > 0 ? (
                                checkListFiles?.map((item: any, index: any) => {
                                    return (
                                        <>
                                            {item.type === "image" ? (
                                                <Card
                                                    style={{
                                                        background: "#f3eeeec4",
                                                        padding: 5,
                                                        margin: 3,
                                                        borderRadius: 5,
                                                    }}
                                                >
                                                    <img
                                                        key={index}
                                                        src={item?.file}
                                                        alt={"preview"}
                                                        style={{
                                                            objectFit: "cover",
                                                            width: 150,
                                                            height: 150,
                                                            display: "flex",
                                                            boxShadow: "none",
                                                            borderRadius: 5,
                                                            background: "gray",
                                                            margin: 5,
                                                        }}
                                                    />
                                                    <CardActions
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        <DownloadOutlined
                                                            onClick={() => onHandleDownload(item?.file, "anexo" + (index + 1))}
                                                            style={{
                                                                height: 24,
                                                                width: 24,
                                                                fill: "#00B700",
                                                                cursor: "pointer",
                                                            }}
                                                        />

                                                        {!getCurrentUser.configs.isManager && (
                                                            <HideImageOutlined
                                                                onClick={() => {
                                                                    const newList = checkListFiles.filter(
                                                                        (it) => it.id !== item.id
                                                                    );
                                                                    setCheckListFiles(newList);
                                                                }}
                                                                style={{
                                                                    height: 24,
                                                                    width: 24,
                                                                    fill: "red",
                                                                    cursor: "pointer",
                                                                }}
                                                            />
                                                        )}

                                                        <FullscreenOutlined
                                                            onClick={() => onHandleFullScreen(item?.file, "anexo" + (index + 1))}
                                                            style={{
                                                                height: 24,
                                                                width: 24,
                                                                fill: "blue",
                                                                cursor: "pointer",
                                                            }}
                                                        />
                                                    </CardActions>
                                                </Card>
                                            ) : (
                                                <Card
                                                    key={index}
                                                    style={{
                                                        background: "#f3eeeec4",
                                                        padding: 5,
                                                        margin: 3,
                                                        borderRadius: 5,
                                                    }}
                                                >
                                                    <FilePresentOutlined
                                                        style={{
                                                            objectFit: "cover",
                                                            width: 150,
                                                            height: 150,
                                                            display: "flex",
                                                            boxShadow: "none",
                                                            borderRadius: 5,
                                                            background: "transparent",
                                                            fill: "#00b70080",
                                                            margin: 5,
                                                        }}
                                                    />
                                                    <CardActions
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        <DownloadOutlined
                                                            onClick={() => onHandleDownload(item?.file, "anexo" + (index + 1))}
                                                            style={{
                                                                height: 24,
                                                                width: 24,
                                                                fill: "#00B700",
                                                                cursor: "pointer",
                                                            }}
                                                        />

                                                        {!getCurrentUser.configs.isManager && (
                                                            <HideImageOutlined
                                                                onClick={() => {
                                                                    const newList = checkListFiles.filter(
                                                                        (it) => it.id !== item.id
                                                                    );
                                                                    setCheckListFiles(newList);
                                                                }}
                                                                style={{
                                                                    height: 24,
                                                                    width: 24,
                                                                    fill: "red",
                                                                    cursor: "pointer",
                                                                }}
                                                            />
                                                        )}

                                                        <FullscreenOutlined
                                                            onClick={() => onHandleFullScreen(item?.file, "anexo" + (index + 1))}
                                                            style={{
                                                                height: 24,
                                                                width: 24,
                                                                fill: "red",
                                                                cursor: "pointer",
                                                            }}
                                                        />
                                                    </CardActions>
                                                </Card>
                                            )}
                                        </>
                                    );
                                })
                            ) : (
                                <Box style={{ display: "flex" }}>
                                    <Chip
                                        sx={{
                                            color: "#00B700",
                                            width: selectedChecklist.id ? -1 : 200,
                                            "& .MuiChip-icon": {
                                                marginLeft: "0px",
                                            },
                                        }}
                                        disabled={!inInsert}
                                        label="Anexar"
                                        icon={
                                            <Fab
                                                size="small"
                                                aria-label="add"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (fileInputRef.current) {
                                                        fileInputRef.current.click();
                                                    }
                                                }}
                                                disabled={
                                                    checkListFiles.length === 3 ||
                                                    ((selectedChecklist?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean)
                                                }
                                                sx={{
                                                    marginRight: "8px",
                                                    background: "#00B700",
                                                    color: "#ffff",
                                                    "& .disabled": {
                                                        background: "gray",
                                                    },
                                                    "&:hover": {
                                                        background: "#00B700",
                                                        color: "#ffff",
                                                    },
                                                }}
                                            >
                                                <AddOutlined
                                                    sx={{
                                                        background: "#00B700",
                                                        color: "#ffff",
                                                        "& .disabled": {
                                                            background: "gray",
                                                        },
                                                        "&:hover": {
                                                            background: "#00B700",
                                                            color: "#ffff",
                                                        },
                                                    }}
                                                />
                                            </Fab>
                                        }
                                    />
                                </Box>
                            )}

                            {checkListFiles && checkListFiles?.length > 0 && (
                                <Box
                                    className="col-md-6"
                                    style={{ margin: "15px 0px 15px 0px" }}
                                >
                                    <Fab
                                        size="small"
                                        aria-label="add"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (fileInputRef.current) {
                                                fileInputRef.current.click();
                                            }
                                        }}
                                        disabled={
                                            checkListFiles.length === 3 ||
                                            ((selectedChecklist?.name &&
                                                !inEdit &&
                                                !inInsert) as boolean)
                                        }
                                        sx={{
                                            marginRight: "5px",
                                            background: "#00B700",
                                            color: "#ffff",
                                            "& .disabled": {
                                                background: "gray",
                                            },
                                            "&:hover": {
                                                background: "#00B700",
                                                color: "#ffff",
                                            },
                                        }}
                                    >
                                        <AddOutlined />
                                    </Fab>
                                </Box>
                            )}
                        </Box>
                    </Box>

                    {/* OBSERVAÇÕES */}
                    <Box mt={2} className="tw-min-w-0">
                        <FormControl
                            className="form-group"
                            style={{ display: "flex", width: "100%", marginBottom: 5 }}
                        >
                            <InputLabel
                                id="demo-multiple-password-label"
                                shrink
                                disabled={false}
                                style={{ fontFamily: "Prometo" }}
                            >
                                Observações
                            </InputLabel>
                            <TextField
                                name="name"
                                fullWidth
                                autoComplete="off"
                                multiline
                                rows={5}
                                InputProps={{
                                    label: "Observações",
                                    notched: true,
                                    style: { fontFamily: "Prometo" },
                                }}
                                disabled={false}
                                value={form.notes}
                                onChange={(event) => {
                                    setForm({ ...form, notes: event.target.value })
                                }}
                                type="text"
                                className="form-control-login"
                                placeholder="Digite a observação (Opcional)"
                            />
                            <IconButton
                                aria-label="toggle password visibility"
                                className="visibility-password"
                                disabled
                                onMouseDown={(e: SyntheticEvent) => { }}
                                edge="end"
                                size="large"
                            >
                                <AbcOutlined />
                            </IconButton>
                        </FormControl>
                        <Alert
                            style={{
                                borderRadius: 5,
                                padding: 10,
                                marginBottom: 20,
                            }}
                            severity="info"
                        >
                            {
                                "Digite a observação, detalhe da melhor forma possível caso seja necessário."
                            }
                        </Alert>
                    </Box>
                </Paper>
            ),
        },
    ], [
        getCurrentUser.configs.isManager,
        checkListFiles,
        form,
        inEdit,
        inInsert,
        selectedChecklist,
        checkListType,
        checkListTypesList,
        toggle
    ]);

    useEffect(() => {
        setFilteredList(
            getFilteredList(
                ["checkTypeName", "vehiclePlate", "vehicleName", "driverName", "checkStatusName"],
                checkListsList,
                query
            )
        );
    }, [query, checkListsList]);

    const DetailsModal = useMemo(() => {
        return (
            <Rmodal
                open={isOpenDetails}
                toast={
                    <Toast
                        ref={toastModalRef}
                        position="center"
                        onShow={() => {
                            setIsToastVisible(true);

                            if (validationText) {
                                setTimeout(() => {
                                    setFieldsIsValid(true);
                                    setIsToastVisible(false);
                                }, 3000);
                            }
                        }}
                    />
                }
            >
                <Paper className="checklist-form-surface tw-flex tw-flex-col tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-none tw-transition-all tw-duration-300 tw-ease-gtr-smooth dark:tw-bg-slate-900" elevation={0} sx={{ ...style2, width: { xs: "calc(100vw - 24px)", sm: "min(92vw, 920px)" } }}>
                    {inEdit && checklistLetter}
                    {inInsert && <Box
                        className="checklist-form-surface tw-w-full tw-flex-1 tw-overflow-y-auto tw-bg-white tw-p-3 dark:tw-bg-slate-900"
                        sx={{
                            background: "#fff", borderRadius: 0, maxHeight: "calc(100dvh - 24px)", minHeight: 0, overflowY: "auto", overscrollBehavior: "contain",

                            /* Firefox */
                            scrollbarWidth: "thin",
                            scrollbarColor: "#c1c1c1 transparent",

                            /* Chrome / Edge / Safari */
                            "&::-webkit-scrollbar": {
                                width: "5px",
                            },
                            "&::-webkit-scrollbar-track": {
                                background: "transparent",
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#c1c1c1",
                                borderRadius: "8px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                                cursor: "pointer",
                                backgroundColor: "#9e9e9e",
                            },
                        }}
                    >
                        <Stepper
                            activeStep={activeStep}
                            orientation="vertical"
                            sx={{
                                background: "",
                                width: "100%",
                                minWidth: 0,
                                "& .MuiStepContent-root": {
                                    marginLeft: { xs: 0, sm: 1.5 },
                                    paddingLeft: { xs: 0, sm: 2 },
                                    paddingRight: 0,
                                    borderLeftWidth: { xs: 0, sm: 1 },
                                    minWidth: 0,
                                },
                                "& .MuiCollapse-wrapperInner": { width: "100%", minWidth: 0 },
                                "& .Mui-active": {
                                    fill: "#003f4a",
                                },
                                "& .Mui-completed": {
                                    fill: "#00b700",
                                    color: "#ffff",
                                },
                            }}
                        >
                            {steps.map((step, index) => (
                                <Step key={step.label}>
                                    <StepLabel
                                        optional={
                                            index === steps.length - 1 ? (
                                                <Typography variant="caption">
                                                    Desmarque apenas o que está com problema no veículo
                                                </Typography>
                                            ) : index === 0 ? (
                                                <Typography variant="caption">
                                                    Selecione o tipo de checagem
                                                </Typography>
                                            ) : null
                                        }
                                    >
                                        {step.label}
                                    </StepLabel>
                                    <StepContent>
                                        {step.item}
                                        <Paper
                                            className="tw-grid tw-w-full tw-grid-cols-1 tw-gap-2 tw-border-t tw-border-black/5 tw-pt-3 sm:tw-flex sm:tw-flex-wrap sm:tw-justify-end"
                                            elevation={0}
                                            sx={{
                                                display: { xs: "grid", sm: "flex" },
                                                gridTemplateColumns: "minmax(0, 1fr)",
                                                justifyContent: "flex-end",
                                                alignItems: "center",
                                                flexWrap: "wrap",
                                                width: "100%",
                                                gap: 1,
                                                background: "transparent",
                                                marginTop: 1.5,
                                                paddingTop: 1.5,
                                                borderTop: "1px solid rgba(0,0,0,0.05)",
                                                "@media (max-width: 599.95px)": {
                                                    "& .MuiButton-root": {
                                                        width: "100% !important",
                                                        minWidth: "0 !important",
                                                        minHeight: "44px !important",
                                                        margin: "0 !important",
                                                    },
                                                },
                                            }}
                                        >
                                            <Button 
                                                type="button"
                                                style={{
                                                    fontFamily: "Prometo",
                                                    color: "#ffff",
                                                    background: "#00b700",
                                                    margin: 5,
                                                }}
                                                onClick={
                                                    () => {
                                                        if (index === steps.length - 1) {
                                                            onSave();
                                                        } else {
                                                            handleNext();
                                                        }
                                                    }
                                                }
                                                className="btn btn-primary btn-block login-button tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                                                sx={{ order: 3, minWidth: 120, minHeight: 40, borderRadius: 2, backgroundColor: "#00B700", boxShadow: "none", "&:hover": { backgroundColor: "#009900", boxShadow: "0 6px 14px rgba(0,183,0,0.20)" } }}
                                                disabled={
                                                    (index === 0 && !checkListType?.name) || isImpersonationLocked()
                                                }
                                            >
                                                {index === steps.length - 1 ? <SendToMobileOutlined style={{ marginRight: 5 }} /> : <ArrowForwardOutlined style={{ marginRight: 5 }} />}
                                                <Typography
                                                    className="forgot-password"
                                                    style={{
                                                        fontFamily: "Prometo",
                                                        fontSize: "16px",
                                                        color: "#ffff",
                                                    }}
                                                >
                                                    {index === steps.length - 1 ? "Salvar" : "Próximo"}
                                                </Typography>
                                            </Button>

                                            <Button
                                                type="button"
                                                style={{
                                                    fontFamily: "Prometo",
                                                    color: "#ffff",
                                                    background: "orange",
                                                    margin: 5,
                                                }}
                                                onClick={() => handleBack()}
                                                disabled={index === 0}
                                                className="btn btn-primary btn-block tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                                                sx={{ order: 2, minWidth: 108, minHeight: 40, borderRadius: 2, backgroundColor: "#f59e0b", boxShadow: "none", "&:hover": { backgroundColor: "#d97706" } }}
                                            >
                                                <UndoOutlined style={{ marginRight: 5 }} />
                                                <Typography
                                                    className="forgot-password"
                                                    style={{
                                                        fontFamily: "Prometo",
                                                        fontSize: "16px",
                                                        color: "#ffff",
                                                    }}
                                                >
                                                    {"Voltar"}
                                                </Typography>
                                            </Button>

                                            <Button
                                                type="button"
                                                style={{
                                                    fontFamily: "Prometo",
                                                    color: "#ffff",
                                                    background: "#dc3545",
                                                    margin: 5,
                                                }}
                                                onClick={() => {
                                                    if (!isToastVisible) {
                                                        handleClose();
                                                    }
                                                }}
                                                className="btn btn-primary btn-block login-button-close tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                                                sx={{ order: 1, minWidth: 108, minHeight: 40, borderRadius: 2, boxShadow: "none", "&:hover": { boxShadow: "0 6px 14px rgba(220,53,69,0.18)" } }}
                                            >
                                                <CloseOutlined style={{ marginRight: 5 }} />
                                                <Typography
                                                    className="forgot-password"
                                                    style={{
                                                        fontFamily: "Prometo",
                                                        fontSize: "16px",
                                                        color: "#ffff",
                                                    }}
                                                >
                                                    Fechar
                                                </Typography>
                                            </Button>
                                        </Paper>
                                    </StepContent>
                                </Step>
                            ))}
                        </Stepper>
                    </Box>}
                </Paper>
            </Rmodal>
        );
    }, [isMobile, checklistLetter, onSave, inEdit, inInsert, activeStep, steps, validationText, isOpenDetails, checkListType?.name, handleClose, isToastVisible]);

    const customerParam = useMemo(() =>
        <>
            {getCurrentUser.configs.isManager && <Box className="col-md-6" style={{ marginBottom: 5, marginTop: 5 }}>
                <Autocomplete
                    id="chip-label-select-customer"
                    className="input-select-customer"
                    style={{
                        width: "100%",
                        minHeight: "56px",
                        height: "56px",
                        backgroundColor: "#ffffff",
                        borderColor: "lightgray",
                    }}
                    options={customersList}
                    value={customer}
                    onChange={(_, option) => {
                        setCustomer(option ?? customerDefault);
                        setVehicleList([]);
                        setSelectedVehicle(null);
                    }}
                    // disabled={!getCurrentUser.configs.isManager}
                    getOptionLabel={(option) => `${option.reducedName}`}
                    noOptionsText={"Nada encontrado"}
                    renderInput={(params) => (
                        <>
                            <FormControl
                                className="form-group"
                                style={{ display: "flex" }}
                            >
                                <InputLabel
                                    id="country-label"
                                    required
                                    style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                    shrink
                                >
                                    Cliente
                                </InputLabel>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Selecione um cliente"
                                    style={{ background: "#ffff", borderRadius: 8 }}
                                    autoComplete="off"
                                    required
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        ...params.InputProps,
                                        notched: true,
                                        label: "Cliente",
                                        classes: {
                                            notchedOutline: "custom-notch",
                                        },
                                    }}
                                />
                            </FormControl>
                        </>
                    )}
                />
            </Box>}

            <Box className={!getCurrentUser.configs.isManager ? "col-md-12" : "col-md-6"} style={{ marginBottom: 5, marginTop: 5 }}>
                <Autocomplete
                    id="chip-label-select-group"
                    className="input-select-group"
                    style={{
                        width: "100%",
                        minHeight: "56px",
                        height: "56px",
                        backgroundColor: "#ffffff29",
                        borderColor: "lightgray",
                    }}
                    options={vehicleList}
                    value={selectedVehicle ?? null}
                    onChange={(_, value) => {
                        setSelectedVehicle(value ?? null);
                    }}
                    disabled={false}
                    getOptionLabel={(option) => option?.name ? `${option?.name} - ${option?.vehiclePlate}(${option?.deviceImei ?? option?.satelliteImei ?? "Sem dispositivo"})` : "Selecione um veículo"}
                    noOptionsText={"Nada encontrado"}
                    renderInput={(params) => (
                        <>
                            <FormControl
                                className="form-group"
                                style={{ display: "flex" }}
                            >
                                <InputLabel
                                    id="state-label"
                                    required
                                    disabled={false}
                                    style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                    shrink
                                >
                                    Veículo
                                </InputLabel>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Selecione um veículo"
                                    autoComplete="off"
                                    required
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        ...params.InputProps,
                                        notched: true,
                                        label: "Veículo",
                                        startAdornment: <LocalShippingRounded style={{ fill: `${vehicleList.find(v => v.name === selectedVehicle?.name)?.vehicleColorName ?? "gray"}` }} />,
                                        classes: {
                                            notchedOutline: "custom-notch",
                                        },
                                    }}
                                />
                            </FormControl>
                        </>
                    )}
                />
            </Box>
        </>,
        [customer,
            customersList,
            getCurrentUser.configs.isManager,
            selectedVehicle,
            vehicleList
        ]);

    return (
        <>
            {DetailsModal}
            <Toast
                ref={toastRef}
                position="center"
                onShow={() => {
                    setIsToastVisible(true);

                    if (validationText) {
                        setTimeout(() => {
                            setFieldsIsValid(true);
                            setIsToastVisible(false);
                        }, 3000);
                    }
                }}
            />
            <GridTemplate
                columns={columns}
                headerName="Checagens"
                isHiddenMenu={false}
                isLoading={loading}
                order={"asc"}
                rows={rowsOptions(filteredList)}
                sortField="description"
                withFilter={true}
                withOptions={true}
                query={query}
                setQuery={(value: string) => setQuery(value)}
                filterPlaceholder={"status, tipo ou veiculo"}
                onRefresh={getAllCheckLists}
                disableReportButton={true}
                enabledCheckListButton={!location?.state?.canView && !getCurrentUser.configs.isDriver || (selectedVehicle?.id ?? -1) > -1 && !getCurrentUser.configs.isDriver}
                onExport={getLastReport}
                disableAddButton={
                    !location?.state?.canCreate || (selectedVehicle?.id ?? -1) <= -1
                }
                disableDeactivatedButton={true}
                handleNext={(activated: string, page: number, size: number) => getAllCheckLists(activated, page, size)}
                handlePrevious={() => { }}
                isLastPage={isLastPage}
                totalPerPage={numberOfElementsPerPage}
                currentPage={pageNumber}
                totalElements={numberOfElements}
                contentHeight={"500px"}
                containerHeight="auto"
                style={{ width: "100%", marginTop: 0, padding: 0 }}
                onAdd={() => {
                    setIsOpenDetails(true);
                    setInInsert(true);
                    setInEdit(false);
                    setLoading(true);
                    setTimeout(() => {
                        setLoading(false);
                    }, 2000);
                }}
                onClickRow={(item: any) => {
                    setIsOpenDetails(true);
                    setSelectedCheckList(item);
                    setInEdit(true);
                    setInInsert(false);
                    // handleOnEditValues(item);
                    setLoading(true);
                    setTimeout(() => {
                        setLoading(false);
                    }, 2000);
                }}
                withCustomerParameter={(location?.state?.customerId ? false : true)}
                customerParameter={customerParam}
            />
        </>
    );
};

const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    maxWidth: 1000,
    maxHeight: "calc(100dvh - 24px)",
    overflow: "hidden",
    bgcolor: "#ffff",
    border: "none",
    boxShadow: "none",
    borderRadius: 4,
    color: "black",
    justifyContent: "stretch",
    alignItems: "stretch",
    lineBreak: "auto",
    padding: 0,
    fontFamily: "Prometo",
};

const style = {
    bgcolor: "#ffff",
    width: "100%",
    maxWidth: "none",
    margin: "8px 0 0",
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr)",
    gap: 1.5,
    border: "none",
    boxShadow: "none",
    borderRadius: 3,
    color: "black",
    justifyContent: "center",
    alignItems: "stretch",
    lineBreak: "auto",
    padding: { xs: 1, sm: 1.5 },
    fontFamily: "Prometo",
    "& > .col-md-12": { width: "100%", minWidth: 0, margin: "0 !important", padding: "0 !important" },
    "& .MuiAutocomplete-root, & .MuiFormControl-root": { width: "100%" },
    "& .MuiOutlinedInput-root": { borderRadius: 2, backgroundColor: "#fff", transition: "box-shadow 180ms ease" },
    "& .MuiInputLabel-root.Mui-focused": { color: "#00B700" },
    "& .MuiOutlinedInput-root.Mui-focused": { boxShadow: "0 0 0 3px rgba(0,183,0,0.12)" },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#00B700" },
    "& .MuiCard-root": {
        backgroundColor: "#f8fafc !important",
        border: "none",
        borderRadius: "12px !important",
        boxShadow: "none",
    },
};

export default CheckListComponent;
